const PAYMENT_TYPES = {
  STAR_BEAT: 'star_beat',
  CREDIT_CARD: 'credit_card',
  CREDIT_CARD_AMEX: 'credit_card_amex',
  CREDIT_CARD_MPI: 'credit_card_mpi',
  PAYPAL: 'paypal',
};

export default PAYMENT_TYPES;
